<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="bmk">
                       <img src="./image/banner.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                       	<div class="blkps">
                           <div class="blkrect"></div>
                           <div class="txtku1">维修记录</div>
                          </div>
                    </div>
                    <div class="mainSty">
                        <div class="blkx">
                            <div class="txtg">{{title}}</div>
                        </div>
						<div class="blkx">
						    <div class="txtq">{{code}}</div>
						</div>
                        <div v-if="estItem.length>0">
							<div class="utMain">
								<div v-for="(item,index) in estItem" :key="index" class="blkf">
								    <div class="blkp"></div>
								    <div style="display:flex">
								        <div class="txti">维修记录{{item.i}}</div>
								        <div class="txtr">{{item.engineerName}}</div>
								    </div>
								    <div class="blkn">
								       <div class="txtj">{{item.supportTime}}</div>
								       <div class="txtu">{{item.engineerTel}}</div>
								    </div>
								</div>
							</div>
						  </div>
						  <div v-else class="nData">暂无数据</div>
                    </div>
					<div class="blku">
					     <div class="blkt">
					        <div class="btn1" @click="toIndex">返回</div>
					     </div>
					</div>
                </div>
            </div>
        </div>
     </div>


</template>
<script>
    export default{
        components:{},
        data(){
            return {
                title:'',
                code:'',
                current:'',
                estItem:[],
            }
        },
        methods:{
            cliSty(index,e){
                this.current=index;
            },
            toIndex(){
				if(this.$route.query.froms==1){
					this.$router.push({path:'/ycapitalDetail',query:{code:this.$route.query.code,tit:this.$route.query.name,id:this.$route.query.id,hardwareTypeId:this.$route.query.hardwareTypeId,froms:1}})
				}else if(this.$route.query.froms==0){
					this.$router.push({path:'/ypropertyDetail',query:{code:this.$route.query.code,tit:this.$route.query.name,id:this.$route.query.id,hardwareTypeId:this.$route.query.hardwareTypeId,froms:0}})
				}else if(this.$route.query.froms==2){
					if(this.$route.query.hId){
						this.$router.push({path:'/rpropertyDetail',query:{code:this.$route.query.code,tit:this.$route.query.name,id:this.$route.query.hId,hardwareTypeId:this.$route.query.hardwareTypeId,froms:2}})
					}else{
						this.$router.push({path:'/rpropertyDetail',query:{code:this.$route.query.code,tit:this.$route.query.name,id:this.$route.query.id,hardwareTypeId:this.$route.query.hardwareTypeId,froms:2}})
					}	
				}else if(this.$route.query.froms==3){
					if(this.$route.query.hId){
						this.$router.push({path:'/rcapitalDetail',query:{code:this.$route.query.code,tit:this.$route.query.name,id:this.$route.query.hId,hardwareTypeId:this.$route.query.hardwareTypeId,froms:3}})
					}else{
						this.$router.push({path:'/rcapitalDetail',query:{code:this.$route.query.code,tit:this.$route.query.name,id:this.$route.query.id,hardwareTypeId:this.$route.query.hardwareTypeId,froms:3}})
					}
					
				}
                
            },
            getData(){
                let data={"assetsId":this.$route.query.id, responseType:this.$route.query.type};
                this.$api.post(`/app/support/getPartSupportRecInfo`,data).then(res=>{
                       if(res.data.code=="0000"){
                            this.estItem=res.data.data.datalist;
                            let i=0;
                            this.estItem.forEach(item=>{
                                    item.i=++i;
									item.finishTime=item.finishTime?this.dayjs(item.finishTime).format("YYYY-MM-DD HH:mm:ss"):'';
                                }
                            )
                       }
                    }
                )
            }
        },
        computed:{
        },
        created(){
            this.title=this.$route.query.name;
            this.code=this.$route.query.code;
            this.getData()
        }
    }
</script>
<style scoped>
	.utMain{
		width: 303px;
		padding: 14px 21px;
		background: #fff;
		margin: 0 auto;
	}
	.nData{
	    width:100%;
	    height:60px;
	    display:flex;
	    justify-content:center;
	    align-items:center;
	    font-size:14px;
		margin-top: 50px;
	}
     .wrap{
            position: fixed;
            top: 0;
            left:0;
            width:100%;
            height:100%;
            z-index:1000;
            overflow: auto;
			overflow-x:hidden;
            background:#e9eef2;
        }
        .wrap_inner{
             min-height: 100%;
             width:100%;
        }
        .wrap_main{
            padding-bottom:50px;
        }
    .mainlist{
        width:100%;
        height:100%;
    }
    .e_rect{
            width: 68px;
            height: 25px;
            line-height:25px;
            background: #ffffff;
            border: 1px solid #707070;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
            color: #666666;
            margin:0 auto;
        }
    .active{
        color: #0080ff;
        border:1px solid #0080ff;
    }
    .bmk{
        position:relative;width: 100%;height: 148px;
    }

    .mainSty{
        /* width:303px;;
        height:140px; */
        /* padding:14px 21px; */
        margin:0 auto;
        border-radius: 4px;
        /* box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16); */
        /* background:#fff; */
        margin-top:20px;

    }
.blku{
	position:relative;display:flex;flex-direction:row;margin-top:30px;margin-bottom:20px;
}
.blkx{
	 width:303px;padding:14px 21px;margin:0 auto;display:flex;align-items: flex-end;margin-bottom:0px;background:#fff;
}
.blkt{
	flex:1;display:flex;justify-content:center;
}
.btn1{
	width: 281px;height: 44px;;text-align:center;line-height:44px;border: 1px solid #0080ff;color:#0080ff;border-radius: 22px;;border-radius: 22px;font-size: 16px;font-weight:400;
}
.txtu{
	flex:1;text-align:right;font-size: 13px;font-weight: 400;color: #333333;
}
.txtj{
	flex:1;text-align:left;font-size: 13px;font-weight: 400;color: #333333;
}
.txtr{
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;flex:1;text-align:right;font-size: 12px;font-weight: 400;color: #333333;
}
.txti{
	flex:1;text-align:left;font-size: 12px;font-weight: 400;color: #333333;
}
.blkn{
	display:flex;height:22px;margin-top:8px;
}
.blkp{
	position:absolute;top:10px;left:0;width: 4px;height: 13px;background: #1aaeff;
}
.blkf{
	position:relative;margin:0 auto;padding:8px 13px;background:#fff;border-bottom:1px solid #f2f2f2
}
.txtg{
	width:290px;height:28px;line-height:28px;overflow:hidden;
		vertical-align: bottom;
    	　　text-overflow:ellipsis;
    	　　white-space:nowrap;flex:1;font-size: 20px;font-weight: 400;color: #333333;
}
.txtq{
	width:290px;height:28px;line-height:28px;overflow:hidden;
		vertical-align: bottom;
		　　text-overflow:ellipsis;
		　　white-space:nowrap;flex:1;font-size: 9px;font-weight: 400;color: #333333;
}
.blkps{
    position:absolute;
    top:48px;
    right:52px;
    width:90px;
    height:90px;
}
.blkrect{
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1{
    margin:4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.txtku2{
    font-size: 16px;
    font-weight: 400;
    color: rgba(255,255,255,0.80);
}
/* .height0{height:140px}
.height1{height:200px}
.height2{height:260px}
.height3{height:320px}
.height4{height:380px}
.height5{height:440px}
.height6{height:500px}
.height7{height:560px}
.height8{height:620px}
.height9{height:680px}
.height10{height:740px}
.height11{height:800px}
.height12{height:860px}
.height13{height:920px}
.height14{height:980px}
.height15{height:1040px}
.height16{height:1100px}
.height17{height:1160px} */
</style>
